import { SVGProps } from "react"
const AdornmentArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M7.412 16.89 3 12.257m0 0 4.412-4.632M3 12.257h18"
    />
  </svg>
)
export default AdornmentArrow
